"use strict";
(function (global) {

  /**
  * Функции реализующие стандартный функционал веб-доступа.
  * @namespace Core
  * @since 5.0.0.4102
  */
  global.Core = {}; 
   
})(window);
